import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardComponent } from './card.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: CardComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class CardRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/card/card-routing.module.ts